import { useEffect, useState } from 'react'

import { getDriftIntel, getGeoIPProperties } from 'api/ContactsAPI'
import {
  fetchEndUserData,
  getDriftProperties,
  getPropertyDefinitions,
  getSystemProperties
} from 'api/CustomerAPI'
import { captureExceptionWithMessage } from 'utils/logRocket'

export default function useDriftContactProperties(endUserId: string) {
  const [propertyDefinitions, setPropertyDefinitions] = useState<any>()
  const [driftProperties, setDriftProperties] = useState<any>()
  const [customProperties, setCustomProperties] = useState<any>()
  const [geoIPProperties, setGeoIPProperties] = useState<any>()
  const [driftIntel, setDriftIntel] = useState<any>()

  const hydrateProperties = async (endUserId: string) => {
    try {
      const [
        { data: propertyDefinitions },
        { data: driftProperties },
        { data: systemProperties },
        { data: geoIPProperties },
        { data: driftIntel },
        { data: user }
      ] = await Promise.all([
        getPropertyDefinitions(),
        getDriftProperties(),
        getSystemProperties(),
        getGeoIPProperties(endUserId),
        getDriftIntel(endUserId, [1]),
        fetchEndUserData(endUserId)
      ])

      const customProperties = propertyDefinitions
        .filter((property: any) => {
          const isHidden = property?.status === 'HIDDEN'
          const isSystemProperty = systemProperties.includes(property.name)
          const isDriftProperty = driftProperties.includes(property.name)
          const isUserProperty = Object.keys(user.attributes).includes(property.name)
          return !isSystemProperty && !isDriftProperty && !isHidden && isUserProperty
        })
        .map((property: any) => property.name)

      setPropertyDefinitions(propertyDefinitions)
      setCustomProperties(customProperties)
      setDriftProperties(driftProperties)
      setGeoIPProperties(geoIPProperties)
      setDriftIntel(driftIntel)
    } catch (error) {
      setDriftProperties(null)
      captureExceptionWithMessage('Error fetching contact properties', error)
    }
  }

  useEffect(() => {
    hydrateProperties(endUserId)
  }, [endUserId])

  return { propertyDefinitions, driftProperties, customProperties, geoIPProperties, driftIntel }
}
